import loadable from '@loadable/component';

const NavBarLazy = loadable(() =>
  import(/* webpackChunkName: "NavBar" */ './NavBar'),
);

export default NavBarLazy;
